'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateValidator = function () {
    function DateValidator() {
        _classCallCheck(this, DateValidator);

        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = {};

        /**
         * Link
         * @param  {Object} scope
         * @param  {Object} element
         * @param  {Object} attrs
         * @param  {Array} requiredCtrls
         * @return {Void}
         */
        this.link = function (scope, element, attrs, modelCtrl) {
            modelCtrl.$validators.date = function (modelValue) {
                var DATE_REGEXP = /^\d{2}[./-]\d{2}[./-]\d{4}$/;

                if (DATE_REGEXP.test(modelValue) || modelValue === undefined || modelValue === null || modelValue === '') {
                    // input is valid
                    return true;
                }

                // input is invalid
                return false;
            };
        };
    }

    /**
     * Factory
     * @return {Object}
     */


    _createClass(DateValidator, null, [{
        key: 'directiveFactory',
        value: function directiveFactory() {
            DateValidator.instance = new DateValidator();
            return DateValidator.instance;
        }
    }]);

    return DateValidator;
}();

exports.default = DateValidator;


/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/dateValidator.js
 **/